import { Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { BaseComponent } from 'src/app/core/base.component';
import { SessionService } from 'src/app/shared/services/session.service';
import { Validators, FormGroup, FormControl } from '@angular/forms';
import { CourseService } from '../../course/course.service';
import { Course } from '../../course/course';
import {STEPPER_GLOBAL_OPTIONS} from '@angular/cdk/stepper';
import { OutingDto } from '../dtos/outing.dto';
import { OutingService } from 'src/app/outing/outing.service';
import { Router } from '@angular/router';
import { StringHelpers } from 'src/app/shared/helpers/string-helpers';
import { provideNativeDateAdapter } from '@angular/material/core';


@Component({
    selector: 'outing-create',
    templateUrl: './outing-create.component.html',
    styleUrls: ['./outing-create.component.scss'],
    providers: [
        {
            provide: STEPPER_GLOBAL_OPTIONS,
            useValue: { showError: true },
        },
        provideNativeDateAdapter()
    ],
    standalone: false
})
export class OutingCreateComponent extends BaseComponent implements OnInit {
  @Output() outingCreationEvent = new EventEmitter<any>();
  @Input() isFirstOuting: boolean;
  
  outingForm = new FormGroup({
    name: new FormControl('',{
      validators: Validators.required
    })
  })

  outingIterationForm = new FormGroup({
    startDateOnly: new FormControl(),
    startTimeOnly: new FormControl(),
    startDate: new FormControl(),
    cost: new FormControl(),
    course: new FormControl(),
    registrationCode: new FormControl()
  });

  minDate: Date = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
  courses: Course[] = [];
  selectedCourse: Course;
  outingDto: OutingDto = new OutingDto();

  constructor(public sessionService: SessionService, 
    private router: Router,
    private courseService: CourseService, 
    private outingService: OutingService,
    stringHelpers: StringHelpers){
    super(sessionService, stringHelpers);
   }

  ngOnInit(): void {
    this.generateRegistrationCode();
  }

  onSave(){
    this.isLoading = true;
    this.outingDto.map(this.outingForm, this.outingIterationForm);
    this.outingDto.createdBy = this.sessionService.getUserId();
    this.outingDto.organizationId = this.sessionService.getUser().organizationId;
    this.outingService.create(this.outingDto).subscribe((results: any) => {
      this.outingCreationEvent.emit(results);
      this.isLoading = false;
      if(!this.isFirstOuting){
        this.router.navigate([`/administration/outing/details/${results.id}`]);
      }
    }, err => {
      this.isLoading = false;
      console.log(err.console.error());
    });
  }

  generateRegistrationCode(){
    this.outingIterationForm.get('registrationCode').patchValue((Math.random() + 1).toString(36).substring(6).toUpperCase());
  }

  setCourseId(course){
    this.outingIterationForm.get('course').patchValue(course);
  }

  setDateTime(){
    const startDateOnly = new Date(this.outingIterationForm.get('startDateOnly').value);
    const startTimeOnly = this.outingIterationForm.get('startTimeOnly').value;
    const startDate = new Date(startDateOnly.getFullYear(), startDateOnly.getMonth(), startDateOnly.getDate(), startTimeOnly.getHours(), startTimeOnly.getMinutes(), startTimeOnly.getSeconds());
    this.outingIterationForm.get('startDate').patchValue(startDate);
  }
}